import Highcharts from 'highcharts';
import { filterByCategory } from "../ranking-sm/data.js";

function getResponseTimeData() {
    const categories = [
        'Czas reakcji: liczba zgłoszeń',
        'Czas reakcji: liczba zamkniętych',
        'Czas reakcji: średni czas (dni)'
    ];
    const data = filterByCategory(categories);

    const validData = data.filter(sm =>
        sm['Czas reakcji: liczba zgłoszeń'] !== undefined &&
        sm['Czas reakcji: liczba zamkniętych'] !== undefined &&
        sm['Czas reakcji: średni czas (dni)'] !== undefined
    );

    validData.forEach(sm => {
        sm.closureRate = Math.round((sm['Czas reakcji: liczba zamkniętych'] / sm['Czas reakcji: liczba zgłoszeń']) * 100 * 10) / 10;
        sm.totalReports = sm['Czas reakcji: liczba zgłoszeń'];
        sm.closedReports = sm['Czas reakcji: liczba zamkniętych'];
        sm.enoughReports = sm.totalReports > 1000
        sm.enoughClosed = sm.closedReports > 100
        sm.valid = sm.enoughReports && sm.enoughClosed
        sm.avgTime = (sm.valid) ? Math.round(Number(sm['Czas reakcji: średni czas (dni)'])) : 0
    });

    return validData.sort((a, b) => (a.valid ? 0 : 1) - (b.valid ? 0 : 1) || a.avgTime - b.avgTime);
}

export default function chartResponseTime(id) {
    if (!document.getElementById(id)) return;

    const data = getResponseTimeData();
    const categories = data.map(item => item.city);
    const timeData = data.map(item => ({ y: item.avgTime, ...item }));

    Highcharts.chart(id, {
        chart: { type: 'bar', backgroundColor: 'transparent' },
        title: { text: 'Average response time (from submission to closure)' },
        subtitle: { text: 'Based on reports from the Uprzejmie Donoszę app (2024–2025)' },
        xAxis: {
            categories: categories,
            title: { text: null },
            labels: { style: { fontSize: '14px' } }
        },
        yAxis: {
            title: { text: 'Days' },
            min: 0
        },
        legend: { enabled: false },
        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function () {
                const point = this.points[0];
                const cityData = data.find(d => d.city === point.key);
                return `<b>${point.key}</b><br/>` +
                    (point.y > 0 ? `Average time: <b>${point.y?.toFixed(0)} days</b><br/>` : '') +
                    `Total reports: ${cityData.totalReports}<br/>` +
                    `Closed reports: ${cityData.closedReports} (${cityData.closureRate.toFixed(0)}%)`;
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                dataLabels: {
                    enabled: true,
                    formatter: function () {
                        if (!this.options.enoughReports)
                            return 'Too few reports';
                        if (!this.options.enoughClosed)
                            return 'Too few closed';
                        return `${this.y} days`
                    }
                }
            }
        },
        credits: { enabled: false },
        series: [{
            name: 'Average time (days)',
            data: timeData,
            color: '#3498db'
        }]
    });
}
